module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-32-f45e0f18b5912e0c31b1b2b6fbe4940e.svg";